import { CssBaseline } from '@mui/material'
import NavAppBar from '../components/NavAppBar'
import desktopImage from '../images/logo_central-desktop.png'
import mobileImage from '../images/logo_central-mobile.png'
import desktopImageDorado from '../images/logo_central-dorado-desktop.png'
import mobileImageDorado from '../images/logo_central-dorado-mobile.png'
import { useEffect, useState } from 'react'
import { useAuth } from '../context/AuthProvider'
import { useTheme } from '../components/ThemeContext'; // Importa el useTheme
import dataService from '../services/Data'

export const Home = () => {
    const { user } = useAuth()
    const [isMobile, setMobile] = useState(window.innerWidth < 740);
    const { isDarkMode } = useTheme(); // Obtener isDarkMode del contexto

    dataService.setToken(user.data.token)
        
    //useEffect(() => {
    //    setMobile(window.innerWidth < 740 ? true : false)
    //    const handleWindowResize = () => {
    //        const bool = window.innerWidth < 740 ? true : false;
    //        setMobile(bool)
    //    }
    //    window.addEventListener('resize', handleWindowResize);
    //    return () => {
    //        window.removeEventListener('resize', handleWindowResize);
    //    }
    //}, []);

    useEffect(() => {
        const handleWindowResize = () => {
            setMobile(window.innerWidth < 740);
        };
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    return (
        <>
            <CssBaseline />
            <NavAppBar />
            <div
                className="home-content"
                style={{
                    backgroundImage: `url(${isMobile ? (isDarkMode ? mobileImageDorado : mobileImage) : (isDarkMode ? desktopImageDorado : desktopImage)}`,
                    height: '90vh',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                }} />
        </>
    )
}

{/*<div className="home-content" style={{ backgroundImage: `url(${isMobile ? (isDarkMode ? mobileImageDorado : mobileImage) : (isDarkMode ? desktopImageDorado : desktopImage)}`, height: '90vh', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}/>*/ }